import React from "react"
import { BrowserRouter, Routes, Route, Switch } from "react-router-dom"
import Login from "../components/login.component"
import Dashboard from "../components/dashboard/dashboard.component"
import { RoutesConfig } from "../config"
import OpenLayout from "./open-layout"
import { AuthContext } from "../context/auth.context"
import { ToastContainer } from "react-toastify"
import Contact from "../components/contact/contact.component"
import Company from "../components/company/company.component"
import Deal from "../components/deal/deal.component"
import Ticket from "../components/ticket/ticket.component"
import WhatsAppContact from "../components/whatsapp-contact/whatsapp-contact.component"
import WhatsAppCompany from "../components/whatsapp-company/whatsapp-company.component"
import WhatsAppDeal from "../components/whatsapp-deal/whatsapp-deal.component"
import WhatsAppTicket from "../components/whatsapp-ticket/whatsapp-ticket.component"
import Admin from "../components/admin/admin.component"
import UserLogin from "../components/login/login.component"
import Invite from "../components/invite/invite.component"

function App() {
	const [auth, setAuth] = React.useState({})
	return (
		<div className="flex flex-col h-full">
			<AuthContext.Provider value={{ auth, setAuth }}>
				<BrowserRouter>
					<Routes>
						<Route path={RoutesConfig.Application} element={<OpenLayout />}>
							<Route path={RoutesConfig.Dashboard} element={<Dashboard />} />

							<Route path={RoutesConfig.Invite} element={<Invite />} />
							<Route path={RoutesConfig.UserLogin} element={<UserLogin />} />

							{/** Admin Pages */}
							<Route path={RoutesConfig.Admin} element={<Admin />} />

							{/* Hubspot OAuth */}
							<Route path={RoutesConfig.Login} element={<Login />} />

							{/* Hubspot IFrame for SMS */}
							<Route path={RoutesConfig.Contact} element={<Contact />} />
							<Route path={RoutesConfig.Company} element={<Company />} />
							<Route path={RoutesConfig.Deal} element={<Deal />} />
							<Route path={RoutesConfig.Ticket} element={<Ticket />} />

							{/** Hubspot IFrame for WhatsApp */}
							<Route
								path={RoutesConfig.WhatsAppContact}
								element={<WhatsAppContact />}
							/>
							<Route
								path={RoutesConfig.WhatsAppCompany}
								element={<WhatsAppCompany />}
							/>

							<Route path={RoutesConfig.WhatsAppDeal} element={<WhatsAppDeal />} />
							<Route
								path={RoutesConfig.WhatsAppTicket}
								element={<WhatsAppTicket />}
							/>
						</Route>
					</Routes>
				</BrowserRouter>
			</AuthContext.Provider>
			<ToastContainer />
		</div>
	)
}

export default App
